import React from 'react';
import LoanProgramTemplate from './LoanProgramTemplate';

export default function USDALoanPage() {
  return (
    <LoanProgramTemplate
      title="USDA Loans"
      subtitle="Our Loan Programs"
      heroImage="https://res.cloudinary.com/ddhrdxc7d/image/upload/v1778098866/in-flight_3_n3rham.png"
      contentImage="https://res.cloudinary.com/ddhrdxc7d/image/upload/v1777907441/USDA_fszf5j.png"
      descriptionBold="USDA loans"
      description="help eligible buyers purchase homes in approved rural and suburban areas while offering attractive terms and zero down options."
      whyBuyersConsider="USDA loans may allow buyers in qualifying areas to purchase a home with no down payment and favorable rates, reducing the upfront financial burden."
      eligibilityItems={[
        'Property must be in a USDA-eligible community',
        'Household income must fall within local USDA income limits',
        'Standard credit and debt to income guidelines apply',
        'Buyer must occupy the home as a primary residence',
        'Borrower must meet citizenship or eligible residency requirements',
      ]}
      benefitsItems={[
        'Zero down payment for qualifying applicants',
        'Lower monthly guarantee fee compared to traditional mortgage insurance',
        'Competitive, fixed interest rates',
        'Flexible credit evaluation for eligible profiles',
      ]}
    />
  );
}
